import * as Styles from './styles'

export const SuccessBox = () => {
  return (
    <Styles.CompletedContainer>
      <Styles.CompletedImage />
    </Styles.CompletedContainer>
  )
}
